import { css } from '@emotion/react';
import type { CSSInterpolation } from '@emotion/serialize';
import type { ReactNode } from 'react';

import { typography } from '@adflow/frontend/ui-theme';

const styles = {
	container: css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
	}),
	label: css({ marginBottom: '0.75rem' }),
};

export interface TextWithLabelProps {
	containerStyle?: CSSInterpolation;
	labelType?: keyof typeof typography;
	label: string | ReactNode;
	/**
	 * NOTE: font family and font size should not be tampered with
	 */
	labelStyle?: CSSInterpolation;
	textType?: keyof typeof typography;
	text: string | ReactNode;
	textStyle?: CSSInterpolation;
}

/**
 * Text with a label on it that should line up nicely with single line inputs and their labels.
 */
export function TextWithLabel({
	containerStyle,
	labelType = 'label',
	label,
	labelStyle,
	textType = 'emptySmall',
	text,
	textStyle,
}: TextWithLabelProps) {
	return (
		<div css={[styles.container, containerStyle]}>
			<div css={[styles.label, typography[labelType], labelStyle]}>{label}</div>
			<div css={[typography[textType], textStyle]}>{text}</div>
		</div>
	);
}
